"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyphonClient = exports.SyphonClientOptions = void 0;
const api = __importStar(require("./helpers/api"));
const url_1 = require("./helpers/url");
const ApiResponse_1 = require("./models/ApiResponse");
const Article_1 = require("./models/Article");
const FundamentalData_1 = require("./models/FundamentalData");
const Headline_1 = require("./models/Headline");
const HistoricalBar_1 = require("./models/HistoricalBar");
const Hotlist_1 = require("./models/Hotlist");
const ScanResult_1 = require("./models/ScanResult");
const UpDownRatio_1 = require("./models/UpDownRatio");
/**
 * The Syphon Client Options
 * @export
 * @class SyphonClientOptions
 */
class SyphonClientOptions {
}
exports.SyphonClientOptions = SyphonClientOptions;
/**
 * The Syphon Client class. Provides methods to access the Syphon API.
 *
 * @export
 * @class SyphonClient
 */
class SyphonClient {
    constructor(options) {
        if (!options.token)
            throw new Error('SYPHON_TOKEN_MISSING');
        if (!options.apiUrl)
            throw new Error('SYPHON_URL_MISSING');
        this._apiUrl = options.apiUrl;
        this._token = options.token;
    }
    /**
     * Returns the Up-Down Ratios
     * https://confluence.tradestation.com/display/MI/Syphon+Data+API+Specification
     * GET /market/upDownRatios
     *
     * @return {*}  {Promise<ApiResponse<UpDownRatio[]>>}
     * @memberof SyphonClient
     */
    async upDownRatios() {
        const result = await api.get((0, url_1.buildFullyQualifiedUrl)(this._apiUrl, 'market/upDownRatios'), this._token);
        const upDownRatios = result.map((ratio) => new UpDownRatio_1.UpDownRatio(ratio));
        return new ApiResponse_1.ApiResponse(result, upDownRatios);
    }
    async getHistoricalBarsBySymbol(symbol, interval) {
        const result = await api.get((0, url_1.buildFullyQualifiedUrl)(this._apiUrl, `market/bars/${symbol}/${interval}`), this._token);
        const symbolBars = new HistoricalBar_1.SymbolHistoricalBars();
        // return empty map if we didnt get any bars
        if (!result.bars || !result.bars.length) {
            return symbolBars;
        }
        const historicalBars = result.bars.map((bar) => new HistoricalBar_1.HistoricalBar(bar));
        symbolBars[`${symbol}/${interval}`] = new HistoricalBar_1.HistoricalBars(historicalBars);
        return symbolBars;
    }
    async getHistoricalBars(symbols) {
        const result = await api.post((0, url_1.buildFullyQualifiedUrl)(this._apiUrl, `market/bars/`), {
            symbols: symbols
        }, this._token);
        const symbolBars = new HistoricalBar_1.SymbolHistoricalBars();
        // return empty map if we didnt get any bars
        if (!result.length) {
            return symbolBars;
        }
        result.forEach((elem) => {
            Object.keys(elem).forEach((key) => {
                const historicalBars = elem[key].bars.map((bar) => new HistoricalBar_1.HistoricalBar(bar));
                symbolBars[`${key}`] = new HistoricalBar_1.HistoricalBars(historicalBars);
            });
        });
        return symbolBars;
    }
    async getFundamentals(symbol) {
        const result = await api.get((0, url_1.buildFullyQualifiedUrl)(this._apiUrl, `market/fundamentals/${symbol}`), this._token);
        const fundamentals = {};
        const standardKeys = [
            'announcementDate',
            'consolidated',
            'final',
            'reportingDate'
        ];
        if (result.fundamentals) {
            Object.keys(result.fundamentals).forEach((elem) => {
                const receivedFundamental = result.fundamentals[elem];
                const fundamentalKeys = Object.keys(receivedFundamental);
                if (fundamentalKeys.includes('value')) {
                    fundamentals[elem] = new FundamentalData_1.FundamentalData(receivedFundamental);
                }
                else {
                    const commonKeyValues = {};
                    standardKeys.forEach((sk) => {
                        if (fundamentalKeys.includes(sk)) {
                            commonKeyValues[sk] = receivedFundamental[sk];
                        }
                    });
                    fundamentalKeys
                        .filter((key) => !standardKeys.includes(key))
                        .forEach((key) => {
                        const composedKey = `${elem}${key.substr(0, 1).toLocaleUpperCase() + key.substr(1)}`;
                        fundamentals[composedKey] = new FundamentalData_1.FundamentalData(Object.assign({ value: receivedFundamental[key] }, commonKeyValues));
                    });
                }
            });
        }
        return fundamentals;
    }
    getLimit(top) {
        let targetTop = 50;
        if (top && top > 0) {
            targetTop = top;
        }
        return `?limit=${targetTop}`;
    }
    async getHeadlines(top) {
        const limit = this.getLimit(top);
        const result = await api.get((0, url_1.buildFullyQualifiedUrl)(this._apiUrl, `market/news/headlines${limit}`), this._token);
        if (result.articles.length === 0) {
            return [];
        }
        const headlines = result.articles.map((headline) => new Headline_1.Headline(headline));
        return headlines;
    }
    getSymbolRoot(symbol) {
        // Has the JP:#####-EXCHANGE pattern
        if (symbol.match(/^JP:([1-9][0-9A-Y]\d[0-9A-Y][0-9A-Y]?)(\.[MA])?-(TS|NG|FK|SP)/)) {
            return symbol.split('-')[0];
        }
        // Has only 4 to 5 numbers
        if (symbol.match(/^\d{4,5}$/)) {
            return `JP:${symbol}`;
        }
        return symbol;
    }
    async getHeadlinesBySymbol(symbol, top) {
        const symbolRoot = this.getSymbolRoot(symbol);
        const limit = this.getLimit(top);
        const result = await api.get((0, url_1.buildFullyQualifiedUrl)(this._apiUrl, `market/news/headlines/${symbolRoot}${limit}`), this._token);
        if (result.articles.length === 0) {
            return [];
        }
        const headlines = result.articles.map((headline) => new Headline_1.Headline(headline));
        return headlines;
    }
    async getArticleById(id) {
        // encode uri component only if pipe exists
        if (id.indexOf('|') > -1) {
            id = encodeURIComponent(id);
        }
        const result = await api.get((0, url_1.buildFullyQualifiedUrl)(this._apiUrl, `market/news/article/${id}`), this._token);
        if (result.total === 0) {
            return undefined;
        }
        return new Article_1.Article(result.article);
    }
    async getLatestTSEArticle() {
        const result = await api.get((0, url_1.buildFullyQualifiedUrl)(this._apiUrl, `market/news/tse`), this._token);
        if (result.total === 0) {
            return undefined;
        }
        return new Article_1.Article(result.article);
    }
    async getHotlistByName(hotlistName, exchange, sector) {
        const queryParameters = this.getHotlistQueryParameters(exchange, sector);
        const result = await api.get((0, url_1.buildFullyQualifiedUrl)(this._apiUrl, `market/hotlist/${hotlistName}${queryParameters}`), this._token);
        if (!result) {
            return undefined;
        }
        return new Hotlist_1.Hotlist(result);
    }
    getHotlistQueryParameters(exchange, sector) {
        if (exchange && sector) {
            return `?exchange=${exchange}&sector=${sector}`;
        }
        if (exchange) {
            return `?exchange=${exchange}`;
        }
        if (sector) {
            return `?sector=${sector}`;
        }
        return '';
    }
    async getScanResults(scanName) {
        const result = await api.get((0, url_1.buildFullyQualifiedUrl)(this._apiUrl, `market/scans/${scanName}`), this._token);
        if (!result) {
            return undefined;
        }
        return new ScanResult_1.ScanResults(result.symbols);
    }
}
exports.SyphonClient = SyphonClient;
//# sourceMappingURL=syphon.js.map